import { Box, TableFooter, TablePagination, TableRow } from "@mui/material";
import { useEffect } from "react";

const CustomizableListTableFooter = ({
  count,
  columnCount,
  page,
  setPage,
  pageSize,
  setPageSize,
  disablePagination,
  setResultCount,
  standalone = false,
}) => {
  // Notify parent of the latest count after commit, not during render —
  // otherwise React warns about updating a different component while
  // rendering this one.
  useEffect(() => {
    if (setResultCount) {
      setResultCount(count);
    }
  }, [count, setResultCount]);

  if (disablePagination) {
    return null;
  }
  const Footer = standalone ? Box : TableFooter;
  const Row = standalone ? Box : TableRow;
  return (
    <Footer>
      <Row>
        <TablePagination
          component={standalone ? 'div' : 'td'}
          colSpan={standalone ? undefined : columnCount}
          labelRowsPerPage={standalone ? 'Rows:' : 'Rows per page:'}
          sx={standalone ? {
            borderTop: 1, borderColor: 'divider',
            '& .MuiTablePagination-toolbar': { px: 1.5, py: 1, flexWrap: 'wrap', justifyContent: 'flex-end', gap: 0.5 },
            '& .MuiTablePagination-spacer': { display: 'none' },
            '& .MuiTablePagination-select': { mr: 1 },
            '& .MuiTablePagination-actions': { ml: 1 },
            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': { my: 0.5 },
          } : undefined}
          count={count}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          rowsPerPage={pageSize}
          onRowsPerPageChange={(e) => {
            setPageSize(parseInt(e.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 20, 50]}
        />
      </Row>
    </Footer>
  );
};

export default CustomizableListTableFooter;
